import { getDate } from './utils';

export const DEVICE_CONFIG_COLUMNS = ['DSN', 'labId', 'hostName', 'usbPortId', 'lastUpdatedAt'];
export const SORTED_FILED = {
    id: 'labId',
    header: 'Lab ID',
    cell: (e) => e.labId,
    sortingField: 'labId',
    width: 150,
};
export const DEVICE_CONFIG_COLUMNS_DEFINITION = [
    {
        id: 'DSN',
        header: 'DSN',
        cell: (e) => e.dsn,
        sortingField: 'DSN',
        width: 250,
    },
    SORTED_FILED,
    {
        id: 'hostName',
        header: 'Host name',
        cell: (e) => e.hostName,
        sortingField: 'hostName',
        width: 200,
    },

    {
        id: 'usbPortId',
        header: 'Usb port id',
        cell: (e) => e.usbPortId,
        sortingField: 'usbPortId',
        width: 150,
    },
    {
        id: 'lastUpdatedAt',
        header: 'Updated at',
        cell: (e) => getDate(e.updateTimestamp),
        width: 1000,
    },
];

export const COLLECTION_PREFERENCES_PROPS = {
    pageSizePreference: {
        title: 'Select page size',
        options: [
            { value: 20, label: '20 devices' },
            { value: 50, label: '50 devices' },
            { value: 100, label: '100 devices' },
        ],
    },
    visibleContentPreference: {
        title: 'Select visible columns',
        options: [
            {
                label: 'Main properties',
                options: DEVICE_CONFIG_COLUMNS_DEFINITION.map(({ id, header }) => ({
                    id,
                    label: header,
                    editable: id !== 'name',
                })),
            },
        ],
    },
    cancelLabel: 'Cancel',
    confirmLabel: 'Confirm',
    title: 'Preferences',
    stickyColumnsPreference: {
        firstColumns: {
            title: 'Freeze first column(s)',
            description: 'Keep the first column(s) visible while horizontally scrolling the table content.',
            options: [
                { label: 'None', value: 0 },
                { label: 'First column', value: 1 },
            ],
        },
    },
};
